import { useQueryClient } from "react-query";

export const useInvalidateEventQueries = () => {
  const queryClient = useQueryClient();

  return ({
    shouldInvalidateHomePagePosts = false,
    shouldInvalidateAllEvents = false,
  } = {}) => {
    void queryClient.invalidateQueries("post-show");
    void queryClient.invalidateQueries("posts");
    void queryClient.invalidateQueries("space-show", {
      refetchInactive: true,
    });

    if (shouldInvalidateAllEvents) {
      void queryClient.invalidateQueries(["all", "events", "calendar-view"]);
    }
    if (shouldInvalidateHomePagePosts) {
      void queryClient.invalidateQueries("home-page-posts");
    }
  };
};
